import { RepoState, Product } from '../typings/repo';
import {EmptyDoubleSpaceBlack, EmptyDoubleSpaceGrey, XLCartBlack, XLCartGrey} from "../helpers/configurationHelper";

export const getBaseCabinet = (repo: RepoState, id:string):Product =>
{
    /* apply ruleset so check if product can be chosen */
    const cab = repo.basecabinets.filter(x => x.id === id);
    return cab[0];
}

export const getModules = (repo: RepoState, corner:boolean, includeFull: boolean):Product[] =>
{
    /* apply ruleset so check if product can be chosen */
    return repo.basemodules.filter(x => (corner === (x.isCorner || false)) && ((!corner ? includeFull ? true : x.id === "0144-GM" : true) && !x.isLifter));
}

export const getCabinets = (repo: RepoState, corner:boolean, includeCarts: boolean, includeCartsXL: boolean = false, isLifted: boolean = false):Product[] =>
{
    /* apply ruleset so check if product can be chosen */
    return repo.basecabinets.filter(x => corner === x.isCorner && (includeCarts || !x.isCart) && (includeCartsXL || (x.id !== XLCartGrey && x.id !== XLCartBlack)) && (!isLifted || (x.id !== EmptyDoubleSpaceGrey && x.id !== EmptyDoubleSpaceBlack)))
}

export const getCupboards = (repo: RepoState, corner?:boolean):Product[] =>
{
    /* apply ruleset so check if product can be chosen */
    return repo.cupboards.filter(x => corner ? x.isCorner : !x.isCorner)
}

export const getTabletop = (repo: RepoState, corner?:boolean):Product[] =>
{
    /* apply ruleset so check if product can be chosen */
    return repo.tabletop.filter(x => corner ? x.isCorner : !x.isCorner)
}

export const getToolboards = (repo: RepoState, corner: boolean = false, isLifted: boolean = false):Product[] =>
{
    /* apply ruleset so check if product can be chosen */

    return repo.toolboards.filter(x => (corner ? x.isCorner : !x.isCorner) &&  (isLifted ? (x.id !== "0147-WGB1324K-B" && x.id !== "0144-WGB1324K" ) : true))
}

export interface Group {
    id: string;
    title?: string;
    items: Product[]
}

export const isProductVisible = (product: Product, langCode: string): boolean =>
{
    const raw = product.exclusiveTo;
    if (!raw) return true;
    const codes = raw.split(',').map(c => c.trim());
    return codes.length === 0 || codes.includes(langCode);
}

export const getStep3 = (repo: RepoState):Group[] =>
{
    /* apply ruleset so check if product can be chosen */
    return Object.keys(repo.step3).map(k => ({
        id: k,
        ...repo.step3[k],
        items: repo.step3[k].items.filter(p => isProductVisible(p, repo.langCode)),
    }));
}

export const getStep3Category = (repo: RepoState, categoryId: string): Product[] =>
{
    /* apply ruleset so check if product can be chosen */
    const category = repo.step3[categoryId];
    if (!category) return [];
    return category.items.filter(p => isProductVisible(p, repo.langCode));
}

export const getStep4 = (repo: RepoState):Group[] =>
{
    /* apply ruleset so check if product can be chosen */
    let additional = [];
    const arr = Object.values(repo.step4);
    const keys = Object.keys(repo.step4);
    for(var i in arr)
    {
        const obj = {
            id: keys[i],
            ...arr[i]
        }
        additional.push(obj);
    }
    return additional as Group[];
}


